import { IInvoiceItemTemplate } from './invoice-item-template.model';

export interface IInvoiceTemplate {
  id?: number;
  templateName?: string;
  items?: IInvoiceItemTemplate[];
}

export const defaultValue: Readonly<IInvoiceTemplate> = {};
